import axios from "axios";

axios.defaults.withCredentials = true;

const httpClient = axios.create();
// timeout à 60 seconde
httpClient.defaults.timeout = 60000;

export default
    {
        /**
         * Récupére les demandes winpaie par lot
         */
        async getDemandesWinpaieByLot(id) {
            const demandes = await httpClient.get(process.env.VUE_APP_BACKEND_API_URL + process.env.VUE_APP_URL_WINPAIE + id);
            return demandes.data;
        },

        exportWinpaie(id) {
            return process.env.VUE_APP_BACKEND_API_URL + process.env.VUE_APP_URL_FILE + process.env.VUE_APP_URL_WINPAIE_EXCEL_ZIP + id;
        }
    }